import { post } from '../../utils/api';


export const submitPaymentUpdateSurvey = (url, values) =>
  dispatch =>
    post(url, values)
      .then(() => dispatch({ type: 'PAYMENT_UPDATE_SURVEY_SUBMITTED' }));

